import { render, staticRenderFns } from "./logoHome.vue?vue&type=template&id=460a34e8&scoped=true&"
import script from "./logoHome.vue?vue&type=script&lang=js&"
export * from "./logoHome.vue?vue&type=script&lang=js&"
import style0 from "./logoHome.vue?vue&type=style&index=0&id=460a34e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a34e8",
  null
  
)

export default component.exports